import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { SearchProvider } from 'src/contexts/SearchContext';
import { AuthLayout } from 'src/components/templates/auth/AuthLayout';
import { AuthGuard } from './AuthGuard';
import { LazyLoader } from './LazyLoader';
import { mymeRelatedPageRoutes } from './mymeRelatedPageRoutes';
import { superAdminPageRoutes } from './superadminPageRoutes';

const FeedPage = LazyLoader(lazy(() => import('src/components/pages/feed/FeedPage')));
const LibraryPage = LazyLoader(lazy(() => import('src/components/pages/library/LibraryPage')));

const ProfileOverviewPage = LazyLoader(lazy(() => import('src/components/pages/profile/overview/ProfileOverviewPage')));
const ProfileSettingsPage = LazyLoader(lazy(() => import('src/components/pages/profile/settings/ProfileSettingsPage')));

export const authPageRoutes = {
  path: 'app',
  element: (
    <AuthGuard>
      <SearchProvider>
        <AuthLayout />
      </SearchProvider>
    </AuthGuard>
  ),
  children: [
    {
      path: '/app',
      element: <Navigate to='/app/feed' />
    },
    {
      path: 'feed',
      element: <FeedPage type='auth-custom' title='pages.feed.title_head' />
    },
    {
      path: 'library',
      element: (
        <LibraryPage
          type='auth-default'
          title='pages.library.title_head'
          header={{ text: 'pages.library.title_head' }}
        />
      )
    },
    mymeRelatedPageRoutes,
    superAdminPageRoutes,
    {
      path: 'profile',
      children: [
        {
          path: 'overview/:creatorId',
          element: <ProfileOverviewPage type='auth-custom' title='pages.profile.overview_page_title_head' />
        },
        {
          path: 'settings',
          element: <ProfileSettingsPage type='auth-custom' title='pages.profile.settings_page_title_head' />
        }
      ]
    },
    {
      path: 'settings',
      element: <Navigate to='/app/profile/settings' />
    }
  ]
};

export type AuthPageTitle =
  | 'pages.feed.title_head'
  | 'pages.library.title_head'
  | 'pages.search_results.title_head'
  | 'pages.profile.overview_page_title_head'
  | 'pages.profile.settings_page_title_head';
